import React from 'react';
import {useHistory} from 'react-router';
import {NavMenuItemData} from '@treez-ui/core/header/NavMenuItem';
import {useUIWrapperRoutes} from './useUIWrapperRoutes';
import DashboardIcon from '../../icons/Dashboard.svg';
import PMIcon from '../../icons/PM.svg';
import BrandsIcon from '../../icons/Brands.svg';
import StoreIcon from '../../icons/Store.svg';
import {MSO_DASHBOARD_URL} from '~/utils/Constants';

export const useUIWrapperMenuOptions = (parentOrgId) => {
    const history = useHistory();
    const {centralCatalogUrl, priceTiersUrl, brandTreezUrl, storesUrl} = useUIWrapperRoutes(parentOrgId);
    const redirect = (pathname: string, data: any = null) => {
        history.push({
            pathname,
        });
    };

    const goToDashboard = () => {
        window.location.href = MSO_DASHBOARD_URL;
    };

    const productsOption: NavMenuItemData = {
        icon: <img src={PMIcon} className="MenuItemIcon" />,
        label: 'Product Management',
        subItems: [
            {
                icon: <img src="" className="Sub-Menu-Item-Icon" />, //empty image to add horizontal spacing
                label: 'Central Catalog',
                onClick: () => redirect(centralCatalogUrl),
            },
            {
                icon: <img src="" className="Sub-Menu-Item-Icon" />, //empty image to add horizontal spacing
                label: 'Pricing Management',
                onClick: () => redirect(priceTiersUrl),
            },
        ],
    };

    const brandTreezOption: NavMenuItemData = {
        icon: <img src={BrandsIcon} className="MenuItemIcon" />,
        label: 'BrandTreez',
        onClick: () => redirect(brandTreezUrl),
    };

    const storeTreezOption: NavMenuItemData = {
        icon: <img src={StoreIcon} className="MenuItemIcon" />,
        label: 'Stores',
        onClick: () => redirect(storesUrl),
    };

    const dashboardOption: NavMenuItemData = {
        className: 'MenuItemSpacer',
        icon: <img src={DashboardIcon} className="MenuItemIcon" />,
        label: 'Dashboard',
        onClick: () => goToDashboard(),
    };

    const menuOptions: NavMenuItemData[] = [storeTreezOption, productsOption, brandTreezOption];

    const menuOptionsDash: NavMenuItemData[] = [dashboardOption];

    return {menuOptions, menuOptionsDash};
};
